import { env } from "@/env.mjs";
import {
	Flag,
	MessageSquare,
	Star,
	Share2,
	Link,
	MessageCircle,
	Loader2,
} from "lucide-react";
import { User as UserIcon } from "lucide-react";
// import { useNavigate, useLocation } from "react-router-dom";
// import { Auth, Storage } from "aws-amplify";
import React, {
	ReactNode,
	useCallback,
	useEffect,
	useRef,
	useState,
} from "react";
import { useToast } from "@/components/ui/use-toast";
import { Button } from "@/components/ui/button";
import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
	DialogTrigger,
} from "@/components/ui/dialog";
import { Badge } from "@/components/ui/badge";
import Image from "next/image";
import { getMedia } from "@/services/media";
// import {

//     createChannelModerator,
//     deleteChannelModerator,
//     describeChannel,
//     initiateChat,
//     listChannelMemberships,
//     listChannelMembershipsForAppInstanceUser,
// } from "../../api/chime";

// import { useAuthContext } from "../../providers/auth_provider";
// import { useIdentityService } from "../../providers/identity_provider";
// import { useChatChannelState } from "../../providers/message_provider";
// import {

import {
	EmailIcon,
	EmailShareButton,
	FacebookIcon,
	FacebookShareButton,
	LinkedinIcon,
	LinkedinShareButton,
	WhatsappIcon,
	WhatsappShareButton,
} from "react-share";

import { useRouter } from "next/navigation";
import { usePathname } from "next/navigation";
import {
	getUserInfo,
	isAdmin,
	isAuthenticated,
	isMember,
} from "@/lib/api/client-authentication";
import { signIn, useSession } from "next-auth/react";
import { UserInfo } from "@/lib/types/userInfo";
import { MixpanelTracking } from "@/lib/mixpanel-browser-analytics";
import { UserStatus } from "@/models/user-status";

//import { logError, logTrace } from "../../lib/sentryLogger";
type Props = {
	id: string;
	firstName: string;
	lastName: string;
	email: string;
	pic: string | null | undefined;
	tier: any;
	created: string | null | undefined;
	avgRating: string;
	setIsLoading: any;
	setCanReview: any;
	setShowModal: any;
	setShowReviewModal: any;
	isMember?: boolean;
	isAdmin?: boolean;
	isTeacher?: boolean;
};

export const User = (props: Props) => {
	console.log("USER Page Renrender  ", props);
	const router = useRouter();
	const pathName = usePathname();
	const [isEditing, setIsEditing] = useState(false);
	const [lastName, setLastName] = useState(props?.lastName);
	const [firstName, setFirstName] = useState(props?.firstName);
	const [profileImg, setProfileImg] = useState(
		props?.pic ? getMedia(props?.pic) : ""
	);
	const [reportedReason, setReportedReason] = useState("Sexual Content");

	// const notificationDispatch = useNotificationDispatch();
	const [canChangeImage, setCanChangeImage] = useState(false);
	const [showShare, setShowShare] = useState(false);
	const [loading, setLoading] = useState(false);
	const [chatLoading, setChatLoading] = useState(false);

	const modalRef = useRef<HTMLDialogElement | null>(null);

	const splitParams = pathName.split("/");
	const { toast } = useToast();

	const pathname = usePathname();
	const linksUrl = new URL(pathname, env.NEXT_PUBLIC_APP_DOMAIN);
	let url = linksUrl.href;
	const [isUserAdmin, setIsAdmin] = useState(props.isAdmin ?? false);
	const [isUserMember, setIsMember] = useState(props.isMember ?? false);
	const [isUserAuthenticated, setIsAuthenticated] = useState(
		isUserAdmin || isUserMember
	);
	const { data: session, status, update } = useSession();

	console.log("Profile Pic recieved", props?.pic);

	const [member, setMember] = useState<UserInfo>({
		attributes: {
			sub: "",
			email: "",
			given_name: "",
			family_name: "",
			name: "",
		},
		id: "",
		role: "user",
		tier: "free",
		name: "",
		email: "",
		image: "",
	});

	useEffect(() => {
		console.log("Name", props.firstName, props.lastName);
	}, [props]);

	useEffect(() => {
		const checkIfUserCanChangeImg = async () => {
			if (isUserMember || isUserAdmin) {
				setCanChangeImage(true);
			} else {
				setCanChangeImage(false);
			}
		};

		// const checkUserAuthStatus = async () => {
		//     const resAuth = isAuthenticated();
		//     const resAdmin = isAdmin();
		//     const resMem = isMember(props.id);

		// console.log("Member INIT", member);
		//     const [Auth, Admin, Mem] = await Promise.all([
		//         resAuth,
		//         resAdmin,
		//         resMem,
		//     ]);
		//     console.log(`AUTH ${Auth} Admin ${Admin} Mem ${Mem}`);
		//     //If auth status doesn't change no need for re-render
		//     Auth != isUserAuthenticated && setIsAuthenticated(Auth);
		//     Admin != isUserAdmin && setIsAdmin(Admin);
		//     Mem != isUserMember && setIsMember(Mem);
		// };
		// //Should revalidate after set interval to ensure Admin Status?
		// //setInterval(()=>checkUserAuthStatus(),300000) //evry 5 minutes
		// checkUserAuthStatus();
		checkIfUserCanChangeImg();
		getUserInfo().then((memdata) => {
			setMember(memdata);
		});

		// checkIfUserIsTeacher();
	}, []);

	const setProfilePic = (img: string) => {
		console.log("------Setting Profile Pic for ", img);
		if (img) {
			setProfileImg(getMedia(img));
		}
	};

	// const checkIfUserIsTeacher = () => {
	//     if (
	//         props.tier?.type === "Teacher" ||
	//         props.tier?.type === "TeacherPlus"
	//     ) {
	//         setIsTeacher(true);
	//     }
	// };

	// const checkIfUserCanComment = async () => {
	//     if (await isAuthenticated() && !isMember(props?.id)) {
	//         if (isTeacher) {
	//             let name = props?.firstName + " " + props?.lastName;
	//             const channelName = member.Name + "_" + name;
	//             // const list = (await listChannelMembershipsForAppInstanceUser(
	//             //     member.userId
	//             // )) as any;
	//             const result = await fetch(`/api/api/user-channels?id=${member.userId}`)
	//             const list = await result.json()
	//             const chatExist = list
	//                 ? list.find(
	//                     (l: any) =>
	//                         l.ChannelSummary.Name === channelName ||
	//                         l.ChannelSummary.Name === name + "_" + member.Name
	//                 )
	//                 : props?.setCanReview(false);
	//             if (chatExist !== undefined) {
	//                 props?.setCanReview(true);
	//             }
	//         } else {
	//             props?.setCanReview(true);
	//         }
	//     }
	// };

	const checkIfUserCanComment = async () => {
		if ((await isAuthenticated()) && !isUserMember) {
			console.log("====USER CAN COMMENT");
			if (props.isTeacher) {
				//member.userId is whatever the identifier is for the profile
				//if this is a client component use "api/user-channels" instead of listUserChannels
				const res = await fetch(`/api/user-channels?id=${props.id}`);

				const list = (await res.json()).channels;
				const chatExist = list
					? list.find((l: any) => {
							const createMemberArn = fetch("/api/endpoint", {
								method: "POST",
								body: JSON.stringify({ id: session?.user?.id }),
							});
							l?.member === createMemberArn ||
								l?.owner === createMemberArn;
					  })
					: props?.setCanReview(false);
				if (chatExist !== undefined) {
					props?.setCanReview(true);
				}
			} else {
				props?.setCanReview(true);
			}
		}
		console.log("====USER CANNOT COMMENT");
	};
	const launchReviewModal = async () => {
		await checkIfUserCanComment();

		props?.setShowReviewModal(true);
	};

	const uploadProfilePic = async (e: any) => {
		setLoading(true);

		console.log("Uploading Pic for ", session?.user);
		const picName = e.name;
		let location = `${session?.user?.id}/profile/${picName}`;

		//This would be converted to whatever route handlers is used these calls
		const res = await fetch(
			`/api/pictureUrl?location=${encodeURIComponent(location)}`
		);
		// const res = await fetch(`/api/pictureUrl?location=2`)
		console.log("---------Upload URL ", res.url);

		const response = await res.json();
		await fetch(response?.url!, {
			method: "PUT",
			body: e,
		});
		setProfilePic(location);
		const picRes = await fetch("/api/user/profile/picture", {
			method: "PUT",
			body: JSON.stringify({ userId: props.id, location }),
		});
		// const picLoc = await picRes.json()
		// console.log("PICTURE UPDATE ", picLoc)
	};

	const statusPayment = async () => {
		const res = await fetch(
			`/api/user/profile?id=${session?.user?.id}&area=status`
		);
		const response = await res.json();
		return response?.status === UserStatus.PAYMENT;
	};

	const startChat = async () => {
		MixpanelTracking.getInstance().chatButtonClicked({
			action: "'CHAT' button on user profile details clicked",
			userid: props.id,
		});
		if (!isAuthenticated) {
			// router.push("/login");
			signIn(undefined, { callbackUrl: `/profile/${props.id}` });
			return;
		}
		setChatLoading(true);
		if (await statusPayment()) {
			setChatLoading(false);
			toast({
				title: `You have fees outstanding. Please pay outstanding fees to use this feature`,
				variant: "destructive",
				duration: 3000,
			});
			return;
		}

		if (!isUserMember) {
			const profileName = props.firstName + " " + props.lastName;
			const response = await fetch("/api/chat", {
				method: "POST",
				body: JSON.stringify({
					metadata: undefined,
					users: {
						requester: {
							id: session?.user?.id,
							name: session?.user?.name,
						}, //The currently login in user
						requested: { id: props.id, name: profileName }, //The profile user being viewed
					},
				}),
			});
			var res = await response.json();
			if (res.errored) {
				setChatLoading(false);
				toast({
					title: res.message,
					variant: "destructive",
					duration: 3000,
				});
			} else {
				MixpanelTracking.getInstance().chatInitiated({
					initiated_from_id: session?.user.id ?? "",
					initiated_to_id: props.id,
				});
				router.push("/chat");
			}
		} else {
			MixpanelTracking.getInstance().chatInitiated({
				initiated_from_id: session?.user.id ?? "",
				initiated_to_id: props.id,
			});
			router.push("/chat");
		}
	};

	const handleEdit = () => {
		setIsEditing(true);
	};

	async function updateUserNameAttributes(
		firstName: string,
		lastName: string
	) {
		{
			/* Update the session value by sending it to the backend. see https://next-auth.js.org/getting-started/client#updating-the-session */
		}
		update({ name: `${firstName + lastName}` });
		await fetch(`/api/user`, {
			method: "PUT",
			body: JSON.stringify({ firstName: firstName, lastName: lastName }),
		});
	}

	const onSubmit = async () => {
		const toastId = toast({
			title: "Saving...",
		});
		try {
			// This will show the 'Saving...' toast

			await updateUserNameAttributes(firstName, lastName);

			// If the update is successful, show the success toast
			toastId.update(
				toast({
					title: "Saved",
					description: `Updated name to ${firstName} ${lastName}`,
				})
			);
		} catch (e: any) {
			// If there's an error, show the error toast
			toastId.update(
				toast({
					title: "Error",
					description: e.message,
				})
			);
		}

		setIsEditing(false);
	};

	const reportUserClick = async () => {
		try {
			const user = await getUserInfo();
			if (!user) {
				signIn(undefined, { callbackUrl: `/profile/${props.id}` });

				// return toast.warn("Login or create an account to report users", {
				//     autoClose: 5000,
				// });

				toast({
					variant: "destructive",
					description: "Login or create an account to report users",
					duration: 5000,
				});
			}

			const toastId = toast({
				description: "Pending",
			});
			let res;
			try {
				// res = await reportUser(props.id, reportedReason)
				res = await fetch("/api/user/report", {
					method: "POST",
					body: JSON.stringify({
						id: props.id,
						reportedReason: reportedReason,
					}),
				});

				toastId.update(
					toast({
						description: "User Reported",
						variant: "default",
					})
				);
			} catch (e) {
				toastId.update(
					toast({
						description: "Failed to send report.",
						variant: "destructive",
					})
				);
			}

			// let res = await toast.promise(reportUser(props.id, reportedReason), {
			//     pending: "Reporting..",
			// });
			// res ? toast.success("User Reported") : toast.error("Failed");
		} catch (e) {
			//user not logged in

			// navigate("/register");
			// return toast.warn("Login or create an account to report users", {
			//     autoClose: 5000,
			// });

			// router.push("/login");
			signIn(undefined, { callbackUrl: `/profile/${props.id}` });

			toast({
				variant: "destructive",
				description: "Login or create an account to report users",
				duration: 5000,
			});
		}
	};
	// console.log("Profile Image ", profileImg);

	return (
		<>
			{props?.id ? (
				<>
					<div className=" bg-gray-50 w-full mb-14 ">
						<div className="flex flex-wrap">
							<div className="container mx-auto">
								<div className="flex flex-wrap">
									<div className="w-full">
										<div className="flex flex-col sm:flex-row flex-wrap w-full text-center sm:text-left items-center justify-around ">
											<div className="flex flex-wrap flex-col py-3 w-1/2">
												<div className="w-full text-2xl font-bold mt-7 mb-7">
													Profile Details
												</div>
												<div className="w-full break-all flex flex-col items-center sm:items-start md:flex-row md:items-center ">
													<div className="profile-pic">
														<label
															htmlFor="pic"
															className="relative">
															{profileImg === "" ? (
																<UserIcon
																	fill="currentColor"
																	stroke="currentColor"
																	strokeLinecap="butt"
																	className="w-full h-44 text-gray-500"
																/>
															) : (
																<>
																	<div
																		className={
																			loading
																				? "block"
																				: "hidden"
																		}>
																		<img
																			src="/images/loading-red.gif"
																			alt=""
																			className="w-9 h-9"
																		/>
																	</div>
																	<div
																		className={
																			loading
																				? "hidden"
																				: "block"
																		}>
																		<img
																			src={profileImg}
																			alt="profile-pic"
																			onLoad={() =>
																				setLoading(false)
																			}
																			className="max-w-[180px] max-h-[180px]"
																		/>
																	</div>
																</>
															)}
															{canChangeImage && !loading && (
																<div
																	className="thumb-overlay "
																	data-bs-toggle="tooltip"
																	data-bs-placement="top"
																	title="Users should not promote political opinion, propaganda or upload any country flag as their profile picture. Add a profile pic (PNG, JPG, GIF)">
																	<img
																		className="absolute w-7 h-7 rounded-full border-none bg-pink-600 p-1 overflow-visible opacity-80 top-2/3 left-3/4 cursor-pointer"
																		src="/images/upload.png"
																		alt=""
																	/>
																</div>
															)}
														</label>
														{canChangeImage && (
															<input
																type="file"
																accept="image/*"
																onChange={(e: any) =>
																	uploadProfilePic(
																		e?.target?.files[0]
																	)
																}
																id="pic"
																hidden
															/>
														)}
													</div>
													<div className=" w-1/12"></div>
													<div className="lg:w-1/2 ">
														<div>
															<div className="u-title font-semibold text-xl">
																<span className="mr-2">
																	{props.firstName}{" "}
																	{props.lastName}
																</span>

																<a href="/membership">
																	<Badge className="uppercase transition-all ease-in-out text-white shadow-[5px_5px_0px_1px_#5fe385] hover:shadow-[0px_0px_#ffffff] hover:bg-blue-400 ">
																		{props?.tier?.type}
																	</Badge>
																</a>
															</div>
														</div>
														<div className="u-size pt-6">
															{props?.email}
														</div>
														<div className="u-size pb-6">
															Joined {props?.created}
														</div>

														<div className="flex flex-row flex-wrap mb-4 w-full justify-center items-center gap-2 space-y-3 sm:justify-start">
															{!props.isMember &&
																props.isTeacher && (
																	<Button
																		className="transition-all ease-in-outtext-white shadow-[5px_5px_0px_1px_#5fe385] rounded-md uppercase hover:shadow-[0px_0px_#ffffff] hover:bg-blue-400"
																		onClick={() =>
																			startChat()
																		}>
																		{chatLoading ? (
																			<Loader2 className="mr-1 animate-spin" />
																		) : (
																			<MessageCircle className="mr-1" />
																		)}
																		Chat
																	</Button>
																)}

															{(props.tier?.type == "Promoter" ||
																props.isTeacher) && (
																<Button
																	variant="outline"
																	className="!mt-0 border-2 font-semibold !ring-amber-300 border-yellow-300 hover:bg-amber-400 focus:border-amber-400 focus:bg-amber-400 hover:border-amber-400 "
																	onClick={() => {
																		launchReviewModal();
																		MixpanelTracking.getInstance().reviewUserDialogLinkClicked(
																			{
																				action:
																					"Review user dialog opened on user profile",
																				userid: props.id,
																			}
																		);
																	}}>
																	{props?.avgRating} / 5{" "}
																	<Star
																		fill="#fde047"
																		stroke="#fde047"
																		className="ml-1"
																	/>
																</Button>
															)}
														</div>
													</div>
												</div>
											</div>

											{!isUserMember && (
												<div>
													<div className="flex flex-row flex-nowrap items-center">
														{isUserAuthenticated && (
															<Dialog>
																{/* REPORT DIALOG */}
																<DialogTrigger asChild>
																	<div className="flex flex-row flex-nowrap items-center ">
																		<Flag
																			fill="currentColor"
																			className="w-4 mr-1"
																		/>
																		<button className="m-y-2 border-none bg-transparent">
																			Report
																		</button>
																	</div>
																</DialogTrigger>
																<DialogContent className="sm:max-w-[425px]">
																	<DialogHeader>
																		<DialogTitle>
																			Report User
																		</DialogTitle>
																		<DialogDescription>
																			Select a reason:
																		</DialogDescription>
																	</DialogHeader>
																	<div
																		className="modal fade"
																		id="reportModal"
																		tabIndex={-1}
																		aria-labelledby="reportModalLabel"
																		aria-hidden="true">
																		<div className="modal-dialog">
																			<div className="modal-content">
																				<div className="modal-body">
																					<div className="form-check">
																						<input
																							value="Sexual Content"
																							className="form-check-input "
																							type="radio"
																							name="flexRadioDefault"
																							id="reason1"
																							onChange={(
																								e
																							) =>
																								setReportedReason(
																									e
																										.target
																										.value
																								)
																							}
																							defaultChecked
																						/>
																						<label
																							className="form-check-label ml-2"
																							htmlFor="reason1">
																							Sexual
																							Content
																						</label>
																					</div>
																					<div className="form-check">
																						<input
																							value="Violence"
																							className="form-check-input"
																							type="radio"
																							name="flexRadioDefault"
																							id="reason2"
																							onChange={(
																								e
																							) =>
																								setReportedReason(
																									e
																										.target
																										.value
																								)
																							}
																						/>
																						<label
																							className="form-check-label ml-2"
																							htmlFor="reason2">
																							Violence
																						</label>
																					</div>
																					<div className="form-check">
																						<input
																							value="Hate or Abuse"
																							className="form-check-input"
																							type="radio"
																							name="flexRadioDefault"
																							id="reason3"
																							onChange={(
																								e
																							) =>
																								setReportedReason(
																									e
																										.target
																										.value
																								)
																							}
																						/>
																						<label
																							className="form-check-label ml-2"
																							htmlFor="reason3">
																							Hate or
																							Abuse
																						</label>
																					</div>
																					<div className="form-check">
																						<input
																							value="Harmful or Dangerous Activity"
																							className="form-check-input"
																							type="radio"
																							name="flexRadioDefault"
																							id="reason4"
																							onChange={(
																								e
																							) =>
																								setReportedReason(
																									e
																										.target
																										.value
																								)
																							}
																						/>
																						<label
																							className="form-check-label ml-2"
																							htmlFor="reason4">
																							Harmful or
																							Dangerous
																							Activity
																						</label>
																					</div>
																					<div className="form-check">
																						<input
																							value="Spam or Misleading"
																							className="form-check-input"
																							type="radio"
																							name="flexRadioDefault"
																							id="reason5"
																							onChange={(
																								e
																							) =>
																								setReportedReason(
																									e
																										.target
																										.value
																								)
																							}
																						/>
																						<label
																							className="form-check-label ml-2"
																							htmlFor="reason5">
																							Spam or
																							Misleading
																						</label>
																					</div>
																				</div>
																			</div>
																		</div>
																	</div>
																	<DialogFooter>
																		<Button
																			type="submit"
																			onClick={
																				reportUserClick
																			}>
																			Report
																		</Button>
																	</DialogFooter>
																</DialogContent>
															</Dialog>
														)}

														<button
															className="ml-4 border-none bg-transparent flex flex-row flex-nowrap"
															onClick={() => {
																setShowShare(true);
																MixpanelTracking.getInstance().shareProfileDialogLinkClicked(
																	window.location.href
																		.split("/")
																		.pop() ?? ""
																);
															}}>
															<Share2
																fill="currentColor"
																className="w-4 mr-1"
															/>
															Share
														</button>
													</div>
												</div>
											)}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					{/* SHARE DIALOG */}
					<Dialog open={showShare} onOpenChange={setShowShare}>
						<DialogContent>
							<DialogHeader>
								<DialogTitle>Share</DialogTitle>
							</DialogHeader>

							<ul>
								<li>
									<FacebookShareButton
										url={url}
										className="flex flex-row items-center"
										onClick={() =>
											MixpanelTracking.getInstance().sharedUserProperty(
												{
													shared_property: "User Profile",
													shared_to: "Facebook",
													profile_user_id: props.id,
													sharer_user_id: session?.user.id,
												}
											)
										}>
										<FacebookIcon
											size={30}
											round={true}
											className=" mr-3"
										/>
										<span className="text">Facebook</span>
									</FacebookShareButton>
								</li>
								<hr className="my-2" />
								<li>
									<WhatsappShareButton
										url={url}
										className="flex flex-row items-center"
										onClick={() =>
											MixpanelTracking.getInstance().sharedUserProperty(
												{
													shared_property: "User Profile",
													shared_to: "Whatsapp",
													profile_user_id: props.id,
													sharer_user_id: session?.user.id,
												}
											)
										}>
										<WhatsappIcon
											size={30}
											round={true}
											className=" mr-3"
										/>
										<span className="text">Whatsapp</span>
									</WhatsappShareButton>
								</li>
								<hr className="my-2" />
								<li>
									<LinkedinShareButton
										url={url}
										title={props?.firstName + " " + props?.lastName}
										className="flex flex-row items-center"
										onClick={() =>
											MixpanelTracking.getInstance().sharedUserProperty(
												{
													shared_property: "User Profile",
													shared_to: "LinkedIn",
													profile_user_id: props.id,
													sharer_user_id: session?.user.id,
												}
											)
										}>
										<LinkedinIcon
											size={30}
											round={true}
											className=" mr-3"
										/>
										<span className="text">LinkedIn</span>
									</LinkedinShareButton>
								</li>
								<hr className="my-2" />
								<li>
									<EmailShareButton
										url={url} //does not work when there is onClick attached
										className="flex flex-row items-center">
										<EmailIcon
											size={30}
											round={true}
											onClick={() =>
												MixpanelTracking.getInstance().sharedUserProperty(
													{
														shared_property: "User Profile",
														shared_to: "Email",
														profile_user_id: props.id,
														sharer_user_id: session?.user.id,
													}
												)
											}
											className=" mr-3"
										/>
										<span className="text">Email</span>
									</EmailShareButton>
								</li>
								<hr className="my-2" />
								<li>
									<button
										className="link-text flex flex-row items-center "
										onClick={() => {
											navigator.clipboard.writeText(url);
											MixpanelTracking.getInstance().sharedUserProperty(
												{
													shared_property: "User Profile",
													shared_to: "Copied Link",
													profile_user_id: props.id,
													sharer_user_id: session?.user.id,
												}
											);
											// notificationDispatch({
											//     type: 0,
											//     payload: {
											//         message: "Copied!",
											//         severity: "success",
											//         autoClose: true,
											//     },
											// });
											toast({ title: "Copied!", duration: 3000 });
										}}>
										<Link className="w-6 h-6  mr-3" />
										<span className="flex flex-row flex-nowrap">
											Copy Link:
											<span className="overflow-ellipsis overflow-hidden whitespace-nowrap w-[100px] ml-1">
												{url}
											</span>
										</span>
									</button>
								</li>
							</ul>

							<DialogFooter>
								<Button type="submit">Close</Button>
							</DialogFooter>
						</DialogContent>
					</Dialog>
				</>
			) : null}
		</>
	);
};
